export default {
	es: {
		enlaces: {
			contacto: "/contacto",
			tutores: "/servicios/tutores",
			titulados: "/servicios/titulados",
			empresas: "/servicios/empresas",
			colaboradores: "/colaboradores",
			ofertas : '/ofertas',
			programas : '/programas',
			faqs: "/faqs",
			cookies: '/politica-de-cookies'
		},
		portalalumno : 'https://privado.programaclave.com/',
		portalalumnoregistro : 'https://privado.programaclave.com/registro',
		portalempresas : 'https://privado.programaclave.com/login/empresas',
		portalempresasregistro : 'https://privado.programaclave.com/solicitar-cuenta',
		portaltutores : 'https://tutor.uvaempleo.com/'
	},
	en: {
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js